import { Component, OnInit, Inject } from '@angular/core';
import { User } from '../user';
import { UserRegistrationService } from '../user-registration.service';
import { Product } from '../product';
import { ProductRegistrationService } from '../product-registration.service';
import { DOCUMENT } from '@angular/common';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SignupComponent } from '../signup/signup.component';
import { UserdataComponent } from '../userdata/userdata.component';
// import { BasicloginComponent } from '../basiclogin/basiclogin.component';
// import { IntermediateloginComponent } from '../intermediatelogin/intermediatelogin.component';
// import { PremiumloginComponent } from '../premiumlogin/premiumlogin.component';
import { ChatbotComponent } from '../chatbot/chatbot.component';

@Component({
  selector: 'app-mainpage',
  templateUrl: './mainpage.component.html',
  styleUrls: ['./mainpage.component.css']
})
export class MainpageComponent implements OnInit {
  flagsignup=0;
  flagshow=0;
  flag=0;
  flagBMR = 0;
  name;
  message2;
  message1;
  product1;
  user: User = new User("","",0,"","","");
  message: any;
  user1:User;
  uname;
  udesc;
  uprice;
  messagep;
  product:Product;
  age;
  gender;
  wt;
  ht;
  receivedmsg;
  height:number;
  weight:number;
  Age:number;
  Bmr:number;
  newsletter:String="";
  constructor(@Inject(DOCUMENT) private _document,private service: UserRegistrationService,private service1: ProductRegistrationService,public dialog: MatDialog) { }
  public registerProcess(){
    let response = this.service.doRegistration(this.user);
    response.subscribe((data) => this.message = (data));
    this.flagsignup=0;
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
}
subs(){
  if(this.newsletter!="")
  alert("Thanks for subscribing");
  else{
    alert("Please mention your email");
  }
}
  register(){
    this.flagsignup=1;
  }
  ngOnInit() {
    this._document.body.style.background = 'white';
  }
  show(){
    // this.flagsignup=0;
    // this.flagshow=1;
    // this.flag=1;
    // this.user1=this.service.userData();
    const dialogRef = this.dialog.open(UserdataComponent,
      {
        data:{name:this.receivedmsg}
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  closetable(){
    this.flagshow=0;
  }
  findbyna()
  {
    this.flag=1;
    var a=prompt("Write the username for displaying their details");
    this.findbyuser(a);
  }
  findbyuser(a){
    this.flagshow=1;
    this.flag=1;
    let response = this.service.findbyName(a);
    response.subscribe((data) => this.message1 = (data));
  }
  deleteUsers() {
    var e=confirm("Do you really want to delete all the records?")
    if(e==true){
    let response = this.service.deleteAll();
    response.subscribe((data) => this.name = (data));
    }
  }
  delbyname()
  {
    var a=prompt("Write the username for deleting their details");
    this.deletebyuser(a);
  }
  deletebyuser(a){
    var e=confirm("Do you really want to delete the record?")
    if(e==true){
    let response = this.service.deletebyName(a);
    response.subscribe((data) => this.message2 = (data));
    }
  }
  // freeplan(){
  //   this.uname=prompt("Write your username");
  //   // this.product1=new Product();
  //   this.udesc="Standard";
  //   this.uprice="Free";
  //   // console.log(this.product1);
  //   console.log(this.uname);
  //   this.product=new Product("this.uname","this.udesc","this.uprice");
  //    var response=this.service1.doProductRegistration(this.product);
  //    response.subscribe((data) => this.messagep = (data));
  // }



  bmr()
  {
    this.height=parseInt(this.ht);
    this.weight=parseInt(this.wt);
    this.Age=parseInt(this.age);
    if(this.gender=="Male"||this.gender=="male"){
      this.Bmr= (10*this.weight) + (6.25*this.height) - (5*this.Age) + 5;
    }
    else{
      this.Bmr= (10*this.weight) + (6.25*this.height) - (5*this.Age) - 161;
    }
    this.flagBMR=1;
  }

  openDialog() {
    const dialogRef = this.dialog.open(SignupComponent,
      {
        data:{name:this.receivedmsg}
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  // openBeginner() {
  //   const dialogRef = this.dialog.open(BasicloginComponent,
  //     {
  //       data:{name:this.receivedmsg}
  //     });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }
  // openIntermediate() {
  //   const dialogRef = this.dialog.open(IntermediateloginComponent,
  //     {
  //       data:{name:this.receivedmsg}
  //     });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }
  // openPremium() {
  //   const dialogRef = this.dialog.open(PremiumloginComponent,
  //     {
  //       data:{name:this.receivedmsg}
  //     });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }
  chatbot(){
    const dialogRef = this.dialog.open(ChatbotComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}


